import { useEffect } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import getPoliceProfiles from "../axios/getPoliceProfiles";

/**
 * @description This hook is similar to useQueryPoliceProfiles but it automatically fetches all pages.
 */
const useQueryAllPoliceProfiles = () => {
  const response = useInfiniteQuery(
    ["kepolisian_internasional"],
    ({ pageParam = 1 }) => {
      return getPoliceProfiles({ page: pageParam });
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        const policeProfilesList = allPages.flatMap(
          (page) => page.kepolisian_internasional.data,
        );
        if (
          policeProfilesList.length < lastPage.kepolisian_internasional.total
        ) {
          return lastPage.kepolisian_internasional.current_page + 1;
        }
        return undefined;
      },
    },
  );

  const { hasNextPage, isFetchingNextPage, fetchNextPage } = response;

  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);

  return response;
};

export default useQueryAllPoliceProfiles;
